import { monthKeyFromStartDate } from "@/domains/global-dashboard/utils/chart-utils";
import { OrganizationOverviewData } from "@/shared/types/overviewTypes";
import { ServiceLineStatus } from "@/shared/types/serviceLineTypes";

/** Raw counts for one reporting month (service lines by status). */
export type FleetMonthSnap = {
  active: number;
  exhausted: number;
  offline: number;
  noTerminal: number;
  suspended: number;
  total: number;
};

/** Create a map of fleet month snapshots by month key for an account. */
export function fleetSnapshotByYm(organization: OrganizationOverviewData): Map<string, FleetMonthSnap> {
  const map = new Map<string, FleetMonthSnap>();
  if (!organization.summary?.length) return map;
  for (const row of organization.summary) {
    const statuses = row.serviceLinesSummary?.statuses ?? [];
    const fleetSnapshot: FleetMonthSnap = {
      active: statuses.find((st) => st.status === ServiceLineStatus.ACTIVE)?.value ?? 0,
      exhausted: statuses.find((st) => st.status === ServiceLineStatus.EXHAUSTED)?.value ?? 0,
      offline: statuses.find((st) => st.status === ServiceLineStatus.OFFLINE)?.value ?? 0,
      noTerminal: statuses.find((st) => st.status === ServiceLineStatus.NO_UT)?.value ?? 0,
      suspended: statuses.find((st) => st.status === ServiceLineStatus.SUSPENDED)?.value ?? 0,
      total: statuses.reduce((a, s) => a + s.value, 0),
    };
    map.set(monthKeyFromStartDate(row.startDate), fleetSnapshot);
  }
  return map;
}